const React = require('react')
const PropTypes = require('prop-types')
const _ = require('lib/underscore')
const social_links = require('data/social_links')
const SocialLink = require('./social_link')
const ContactMeButton = require('./contact_me_button')
const isAllowedFeature = require('module/user/helpers/is_allowed_feature')

function isValidSocialLink(link) {
    const valid_social_link = _.findWhere(social_links, { id: link.platform })
    return !! valid_social_link
}

function renderSocialLink(link, i) {
    const social_link_data = _.findWhere(social_links, { id: link.platform })

    return (
        <SocialLink key={i} user_data={link} social_link_data={social_link_data} />
    )
}

function SocialLinks({ user }) {
    const valid_social_links = user.apps.filter(isValidSocialLink)
    const show_contact_button = (
        user.contact_me.enabled
        && user.contact_me.display !== 'form'
        && isAllowedFeature(user, 'contact_me')
    )

    if (valid_social_links.length || show_contact_button) {
        return (
            <section className="social-links inset">
                <ul className="inline">
                    {show_contact_button && <ContactMeButton user={user} />}
                    {valid_social_links.map(renderSocialLink)}
                </ul>
            </section>
        )
    }

    // no social links or contact button
    return null
}

SocialLinks.propTypes = {
    user: PropTypes.shape({
        apps: PropTypes.arrayOf(PropTypes.object),
        contact_me: PropTypes.object,
    }).isRequired,
}

module.exports = SocialLinks
